import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
    'providedIn': 'root'
})
export class LocalDataService {
    // private data = [];

    constructor(private httpClient: HttpClient) {
    }

    public async readFile(filename: string) {
        const observable = this.httpClient.get(filename);
        const response = await firstValueFrom(observable);
        return response;
    }

    // Zipcode example - copied over for convenience
    // public loadZipcodes() {
    //     const promise = new Promise((resolve, reject) => {
    //         this.httpClient.get('assets/data/us.json').toPromise()
    //         .then((response: []) => {
    //             const zipcodes = response;
    //             zipcodes.forEach((zipcodeInfo: TZipcode) => {
    //                 zipcodeInfo.uid = zipcodeInfo.zipcode;
    //                 this.set(zipcodeInfo, zipcodeInfo.uid);
    //             });
    //             resolve(zipcodes.length);
    //         })
    //         .catch(err => {
    //         });
    //     });
    //     return promise;
    // }
}
